export default {
  id: 'recovr.LocatorPairingValidation',
  type: 'recovr.LocatorPairingValidation',
  perform: async cxt => {
    const {
      setActiveStep,
      wizardData
    } = cxt;
    const {
      tag: locator
    } = wizardData;
    try {
      // Check if locator is unactivated
      const isUnactivated = isLocatorUnactivated(locator?.obj);
      if (isUnactivated) {
        setActiveStep('locatorUnactivated');
        return;
      }
      // Check if locator is offline
      const isOffline = isLocatorOffline(locator?.obj);
      if (isOffline) {
        setActiveStep('locatorOffline');
        return;
      }
      // If all validations pass, continue to the summary
      setActiveStep('pairSummary');
    } catch (err) {
      // If there's an unexpected error, go to the default error screen
      setActiveStep('pairingError');
    }
  }
};
function isLocatorOffline(locator) {
  const lastHeartbeat = locator?.data?.data?.lastHeartbeat;
  const effectiveHeartbeatInterval = locator?.data?.data?.effectiveHeartbeatInterval;

  // If no heartbeat or no heartbeat interval data, consider offline
  if (!lastHeartbeat) {
    return true;
  }

  // Check if last heartbeat is older than 3 * effective heartbeat interval
  const offlineThreshold = effectiveHeartbeatInterval ? effectiveHeartbeatInterval * 1000 * 3 : 2 * 60 * 60 * 1000;
  const currentTime = Date.now();
  const cutoffTime = currentTime - offlineThreshold;
  const isOffline = lastHeartbeat < cutoffTime;
  return isOffline;
}
function isLocatorUnactivated(locator) {
  const lastHeartbeat = locator?.data?.data?.lastHeartbeat;
  return !lastHeartbeat;
}